import React from 'react';

export default function GridItem({ label, colSpan, rowSpan, children }) {
  let extraClasses = [];

  if (colSpan) extraClasses.push(`col-span-${colSpan}`);
  if (rowSpan) extraClasses.push(`row-span-${rowSpan}`);

  return (
    <div className={`overflow-hidden rounded-lg bg-white px-2 py-3 shadow flex flex-col items-center sm:p-3 ${extraClasses.join(' ')}`}>
      <dt className="truncate text-sm font-medium text-gray-500">
        {label}
      </dt>
      <dd className="m-0 text-base font-semibold tracking-tight text-gray-900 items-center flex flex-col">
        {children}
      </dd>
    </div>
  );
}
